import { render, staticRenderFns } from "./SmartBinView.vue?vue&type=template&id=531a43a2"
import script from "./SmartBinView.vue?vue&type=script&lang=js"
export * from "./SmartBinView.vue?vue&type=script&lang=js"
import style0 from "./SmartBinView.vue?vue&type=style&index=0&id=531a43a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports